<template>
<div class="view-content">
	  <div class="index">
			<div style="background-color: #fff;">
				<div class="view-content-info">
					<div class="top flex-between flex-center">
						  <!-- 首页顶部左侧分类 -->
						  <div class="top-left">
							  <div class="top-left-item flex-between flex-center" v-for="(item,index) in topcateList" v-if="index<9" :key="item.id" @click="toCate(item.id,0,'')">
								  <img class="top-left-item-icon" :src="item.image"/>
								  <div class="top-left-item-name">{{item.name}}</div>
								  <div class="top-left-item-info">{{item.info}}</div>
								  <img class="top-left-item-right" src="@/assets/images/rightbai.png"/>
								  <div class="top-left-goods" @click.stop="()=>{}" v-if="item.childrenList.length > 0">
									  <div class="flex-start">
										  <div v-if="item.childrenList.length > 0">
											  <div v-for="(value,key) in item.childrenList" v-if="key < 4" :key="key" @click="toCate(item.id,value.id,value.name)" class="top-left-goods-item flex-start flex-center">
												  <img :src="value.image"/>
												  <div class="two">{{value.name}}</div>
											  </div>
										  </div>
										  <div v-if="item.childrenList.length > 4">
											  <div v-for="(value,key) in item.childrenList" v-if="key >= 4 && key < 8" :key="key" @click="toCate(item.id,value.id,value.name)" class="top-left-goods-item flex-start flex-center">
												  <img :src="value.image"/>
												  <div class="two">{{value.name}}</div>
											  </div>
										  </div>
										  <div v-if="item.childrenList.length > 8">
											  <div v-for="(value,key) in item.childrenList" v-if="key >= 8 && key < 12" :key="key" @click="toCate(item.id,value.id,value.name)" class="top-left-goods-item flex-start flex-center">
												  <img :src="value.image"/>
												  <div class="two">{{value.name}}</div>
											  </div>
										  </div>
									  </div>
								  </div>
							  </div>
						  </div>
						  <!-- 首页顶部轮播图 -->
						  <div class="top-right">
								<el-carousel height="470px" :loop="true">
									<el-carousel-item v-for="item in banner" :key="item.id">
										<img :src="item.image" @click="toInfo(item)" style="width: 1018px;height: 470px;object-fit: cover;cursor: pointer;"/>
									</el-carousel-item>
								</el-carousel>
						  </div>
					</div>
				</div>
			</div>
			<div class="view-content-info">
				<!-- <div class="title flex-between flex-center">
					<div class="title-left">最新上架</div>
					<router-link to="/catelist" class="title-right flex-end flex-center">
						<div>查看更多</div>
						<img src="@/assets/images/right.png"/>
					</router-link>
				</div>
				
				<div class="goods-list flex-start flex-center flex-wrap">
					<goods-item v-for="item in newGoods" :info="item" :key="item.id" :icon="1"></goods-item>
				</div> -->
				
				<template v-for="item in cateList">
					<div class="title flex-between flex-center">
						<div class="title-left">{{item.name}}</div>
						<router-link :to="'/catelist?pid='+item.id+'&cate_name=&id=0'" class="title-right flex-end flex-center">
							<div>查看更多</div>
							<img src="@/assets/images/right.png"/>
						</router-link>
					</div>
					
					<div class="goods-list flex-start flex-center flex-wrap">
						<goods-item v-for="value in item.goodsList" :info="value" :key="value.id" :icon="0"></goods-item>
					</div>
				</template>
				
				
				<div class="title flex-between flex-center">
					<div class="title-left">资讯</div>
					<router-link to="/news" class="title-right flex-end flex-center">
						<div>查看更多</div>
						<img src="@/assets/images/right.png"/>
					</router-link>
				</div>
				
				<div class="goods-list flex-start flex-center flex-wrap">
					<router-link :to="'/newsinfo?id='+item.id" v-for="item in newsList" :key="item.id" class="news-item">
						<img class="item-image" :src="item.image"/>
						<div class="news-text">
							<div class="news-name one">{{item.title}}</div>
							<div class="news-time">{{item.releaseTime}}</div>
							<div class="news-info two">{{item.info}}</div>
						</div>
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src
import goodsItem from '@/components/goodsItem.vue'
import {getTypeList,getbannerList,getGoodslist,getNewslist,getCateList} from "@/api/index"
export default {
	name: 'index',
	components:{
		goodsItem
	},
	data(){
		return {
			cateList:[],
			banner:[],
			newGoods:[],
			newsList:[],
			topcateList:[]
		}
	},
	mounted() {
		this.getCate();
	},
	methods:{
		getCate(){
			getCateList({indexStatus:0,parentId:0}).then(res=>{
				if(res.code == 1000){
					this.topcateList = res.data;
				}else{
					return this.$message.error(res.message);
				}
			})
			getTypeList().then(res=>{
				if(res.code == 1000){
					this.cateList = res.data;
				}else{
					return this.$message.error(res.message);
				}
			})
			getbannerList({type:1}).then(res=>{
				if(res.code == 1000){
					this.banner = res.data;
				}else{
					return this.$message.error(res.message);
				}
			})
			getNewslist({page:1,size:3}).then(res=>{
				if(res.code == 1000){
					this.newsList = res.data.list;
				}else{
					return this.$message.error(res.message);
				}
			})
			// getGoodslist({condition:{},page:1,size:8}).then(res=>{
			// 	if(res.code == 1000){
			// 		this.newGoods = res.data.list;
			// 	}else{
			// 		return this.$message.error(res.message);
			// 	}
			// })
		},
		toInfo(info){
			if(info.jumpType == 2){//跳转底部链接
				window.open(info.jumpUrl);
			}
		},
		toGoods(id){
			this.$router.push("/goodsinfo?id="+id);
		},
		toCate(pid,id,cate_name){
			this.$router.push('/catelist?pid='+pid+'&id='+id+'&cate_name='+cate_name);
		}
	}
}
</script>

<style lang="scss" scoped>
	.news-item{
		width: 420px;
		background-color: #fff;
		margin:15px;
		&:last-of-type{
			margin-right: 0px;
		}
		&:first-of-type{
			margin-left: 0px;
		}
		.item-image{
			width: 420px;
			height: 240px;
			object-fit: cover;
		}
		.news-text{
			padding: 20px 30px;
			width: 100%;
			box-sizing: border-box;
			.news-name{
				font-size: 24px;
				font-weight: 500;
				color: #070B13;
			}
			.news-time{
				opacity: 0.6;
				font-size: 16px;
				color: #070B13;
				margin-top: 20px;
			}
			.news-info{
				opacity: 0.6;
				font-size: 16px;
				color: #070B13;
				margin-top: 20px;
				height: 50px;
				line-height: 25px;
			}
		}
	}
	.title{
		padding: 14px 0px;
		.title-left{
			font-size: 24px;
			line-height: 40px;
			color: #070B13;
		}
		.title-right{
			font-size: 20px;
			line-height: 40px;
			color: #070B13;
			opacity: 0.6;
			img{
				width: 24px;
				height: 24px;
				margin-left: 8px;
			}
		}
	}
	.top-left-goods-item{
		padding: 10px;
		img{
			width: 86px;
			height: 86px;
			margin-right: 16px;
			object-fit: cover;
		}
		div{
			font-size: 16px;
			line-height: 23px;
			color: #070B13;
			width: 150px;
		}
	}
	.index{
		.top{
			.top-right{
				width: 1018px;
				height: 470px;
				::v-deep .el-carousel__button{
					background: rgba(255,255,255,0.6);
				}
				::v-deep .is-active .el-carousel__button{
					background: #E91A12;
				}
			}
			.top-left{
				width: 302px;
				height: 470px;
				background: #959393;
				position: relative;
				.top-left-item{
					width: 302px;
					height: 52px;
					cursor: pointer;
					padding: 0px 20px;
					box-sizing: border-box;
					.top-left-goods{
						height: 470px;
						background: #FFFFFF;
						box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.3);
						position: absolute;
						top: 0px;
						left: 302px;
						display: none;
						padding: 20px 30px;
						box-sizing: border-box;
						z-index: 1000;
					}
					.top-left-item-icon{
						width: 20px;
						height: 20px;
						flex: 0 0 20px;
						margin-right: 14px;
					}
					.top-left-item-name{
						font-size: 18px;
						font-weight: 500;
						line-height: 24px;
						color: #FFFFFF;
						width: 80px;
						text-align: left;
						flex: 0 0 80px;
					}
					.top-left-item-info{
						width: 100%;
						font-size: 20px;
						line-height: 24px;
						color: #FFFFFF;
						text-align: left;
					}
					.top-left-item-right{
						width: 24px;
						height: 24px;
						flex: 0 0 24px;
						// display: none;
					}
					// background: #E91A12;
				}
			}
		}
	}
	.top-left-item:hover{
		background: #E91A12 !important;
	}
	.top-left-item:hover .top-left-item-right{
		display: block !important;
	}
	.top-left-item:hover .top-left-goods{
		display: block !important;
	}
</style>
